module.exports = __webpack_public_path__ + "static/media/location.4706790c.svg";